<div class="container-fluid">
	<div class="page-title">
		<div class="row">
			<div class="col-6">
				<h3><mat-icon class="align-middle">assignment</mat-icon> Inventario</h3>
			</div>
		</div>
	</div>
</div>

<div class="container-fluid">

	<div class="row">
		<div class="col-md-5 col-sm-12 col-xs-12">
			<div class="card">
				<div class="card-body">

					<label class="fw-bold">Campaña</label>
					<mat-form-field class="w-100 sel-inv" appearance="outline">
						<mat-select placeholder="Selecciona una opción" (selectionChange)="onSelectedCamp($event);">
							<mat-option *ngFor="let camp of campaignList" [value]="camp.id"
								>{{ camp.name }}</mat-option>
						</mat-select>
					</mat-form-field>

					<!-- <label class="fw-bold mt-1" style="margin-top: -10px">Material</label>
					<mat-form-field class="w-100 sel-inv" appearance="outline">
						<mat-select (selectionChange)="onSelectedMat($event)" placeholder="Selecciona una opción" matTooltip="Seleccione primero una campaña" [matTooltipDisabled]="tooltipMat">
							<mat-option *ngFor="let mat of materials" [value]="mat">
								{{mat.nombre }}
							</mat-option>
						</mat-select>
					</mat-form-field> -->

					<label class="fw-bold mt-1" style="margin-top: -10px">Material</label>
					<mat-form-field class="w-100 sel-inv" appearance="outline">
						<input type="text" style="padding-top: 3px !important;"
							placeholder="Selecciona una opción"
							aria-label="Number"
							matInput
							[formControl]="materialControl"
							[matAutocomplete]="auto">
							<button
								*ngIf="materialControl.value"
								mat-icon-button
								matSuffix
								(click)="clearAutocomplete()"
								aria-label="Clear">
								<mat-icon>close</mat-icon>
							</button>
						<mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onSelectedMat($event)">
						<mat-option *ngFor="let mat of filteredOptions | async" [value]="mat">
							{{mat.nombre }}
						</mat-option>
						</mat-autocomplete>
					</mat-form-field>

					<label class="fw-bold mt-3">Recepción</label>
					<div class="row">
						<mat-slide-toggle class="col-md-6 col-sm-12 col-xs-12" [(ngModel)]="toggleCalcularPeso" (click)="onChangeCalcularPeso($event)">Calcular por Peso</mat-slide-toggle>
						<mat-slide-toggle [(ngModel)]="toggleDanados" class="col-md-6 col-sm-12 col-xs-12">Dañados</mat-slide-toggle>
					</div>

					<div class="d-flex justify-content-between align-items-center mt-2">
						<label class="fw-bold mb-0">Ingresa {{tipoRecepcion}}</label>
						<label class="fw-bold mb-0">{{lblPesoUnitario}}</label>
					</div>
					<div class="d-flex flex-column align-items-end">
						<mat-form-field class="w-100 input-inv mb-0" appearance="outline" id="inp-cant">
							<input matInput type="number" placeholder="Cantidad" [(ngModel)]="cantidad">
						</mat-form-field>
						<label class="lbl-unid">{{resultadoUnidades}}</label>
					</div>

					<div class="d-flex justify-content-center mt-2 mb-2">
						<div 
							class="w-100 d-flex justify-content-center align-items-center div-img-fixed">
							<img *ngIf="imageSrc != undefined " class="img-fluid img-fixed" [src]="imageSrc" alt="">
							<label *ngIf="imageSrc == undefined ">Material sin imagen</label>
						</div>
					</div>

					<div class="d-flex justify-content-end align-items-center mt-1">
						<div class="">
							<div class="d-block">
								<label class="fw-bold">Resultado</label>
							</div>
							<div class="d-flex align-items-center">
								<label class="fw-bold fs-5 me-2">{{resultadoSuma}}</label>
								<div *ngIf="!toggleDanados" class="d-flex align-items-center" [ngStyle]="{'background-color': resultadoCantidad >= 0 ? '#91EBA9' : '#f8d4d4', 'color': resultadoCantidad >= 0 ? '#2B6E3B' : '#dc2626'}">
									<mat-icon>{{resultadoCantidad >= 0 ? 'arrow_drop_up' : 'arrow_drop_down'}} </mat-icon>
									<label class="fw-bold me-2">{{resultadoCantidad < 0 ? resultadoCantidad * -1 : resultadoCantidad}}</label>
								</div>
							</div>
						</div>
					</div>

					<div class="d-flex justify-content-end align-items-center mt-1">

						<div class="w-50">
							<button *ngIf="hasPermissions('save_inventory1',true,true)" mat-flat-button color="primary" class="text-white fw-bold w-100"
								(click)="validationForm()">
								<mat-icon>check</mat-icon> Confirmar
							</button>
						</div>
					</div>

				</div>
			</div>
		</div>
		<div class="col-md-7 col-sm-12 col-xs-12">
			<div class="card">
				<div class="card-body ps-3">
					<div *ngIf="selectedCampaign && selectedIdMaterial; else matsummary">
						<h5 class="fw-bold">Inventario: {{selectedMatNombre}}</h5>
						<mat-divider></mat-divider>
						<div class="row mt-3">
							<div class="col-lg col-md-4 col-sm-6">
								<label class="fw-bold">Esperado</label>
								<div>
									<label class="fw-bold fs-5">{{esperado}}</label>
								</div>
							</div>
							<div class="col-lg col-md-4 col-sm-6">
								<label class="fw-bold">Recibido</label>
								<div>
									<label class="fw-bold fs-5">{{recibido}}</label>
								</div>
							</div>
							<div class="col-lg col-md-4 col-sm-6">
								<label class="fw-bold">Pendiente</label>
								<div>
									<label class="fw-bold fs-5">{{pendiente}}</label>
								</div>
							</div>
							<div class="col-lg col-md-4 col-sm-6">
								<label class="fw-bold">Utilizado</label>
								<div>
									<label class="fw-bold fs-5">{{utilizado}}</label>
								</div>
							</div>
							<div class="col-lg col-md-4 col-sm-6">
								<label class="fw-bold">Actual</label>
								<div>
									<label class="fw-bold fs-5">{{actual}}</label>
								</div>
							</div>
							<div class="col-lg col-md-4 col-sm-6">
								<label class="fw-bold">En línea</label>
								<div class="">
									<label class="fw-bold fs-5">{{en_linea}}</label>
								</div>
							</div>
							<div class="col-lg col-md-4 col-sm-6">
								<label class="fw-bold text-danger">Dañados</label>
								<div>
									<label class="fw-bold fs-5 text-danger">{{danados}}</label>
								</div>
							</div>
						</div>

						<div class="mt-3">
							<mat-progress-bar id="bar-inv" mode="determinate" [value]="porcentaje" color="accent"></mat-progress-bar>

							<div class="d-flex justify-content-end">
								<label class="fw-bold fs-6">{{porcentaje}}%</label>
							</div>
						</div>

						<div class="mt-3">
							<div class="timeline-container">
								<label class="fw-bold">Historial</label>
								<ul class="timeline mt-2">
									<li class="timeline-item" *ngFor="let hist of historial">
										<div class="timeline-dot"></div>
										<div class="timeline-content">
											{{hist.fecha | date: 'dd/MM/yyy HH:mm:ss'}} - {{hist.descripcion}}: {{hist.cantidad}}, {{hist.usuario}}
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<ng-template #matsummary>
						<div class="d-flex justify-content-between">
							<h5 class="fw-bold py-2">Materiales {{ selectedCampaign ? 'de ' + campaignName(selectedCampaign) + ':' : '' }}</h5>
							<!-- button mat-flat-button color="primary" (click)="downloadCajas()" class="mt-2 mb-2 ms-4 text-white float-end" -->
							<button mat-flat-button color="primary" class="text-white" (click)="downloadMatSummary()" [disabled]="!(selectedCampaign) && selectedIdMaterial">
								Descargar lista<mat-icon>download_file</mat-icon>
							</button>
						</div>
						<mat-divider></mat-divider>
						<div class="st-content" *ngIf="selectedCampaign && !loading">
							<div class="st-row" *ngFor="let x of materials">
								<div class="st-cell text">{{ x.nombre }}</div>
								<div class="st-cell progress">
									<div class="st-progress-bar">
										<div class="st-progress-fill" [style.width.%]="x.storage?.perc" [style.background-color]="materialColor(x.storage?.perc ?? 0)"></div>
									</div>
									<span>{{ x.storage?.perc ?? 0 }}%</span>
								</div>
								<div class="st-cell stats">{{ x.storage?.rec ?? 0 }} / {{ x.storage?.qty ?? 0 }}</div>
							</div>
						</div>
					</ng-template>
				</div>
			</div>
		</div>

	</div>
</div>